export default __webpack_public_path__ + "static/media/drakkar-description-information.4c7ac0c0.png";